import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubscriptionDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.SubscriptionDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubscriptionDTO.translate = translateService;
}
this.Applications = [];
this.Name = null;
this.CreditsEUR = null;
this.SubscriptionDTOKey = null;
this._key = this.SubscriptionDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Name:any;
CreditsEUR:any;
Applications:any;
BillingDetails:any;
private _SubscriptionDTOKey:any;
get SubscriptionDTOKey(): any {
    return this._SubscriptionDTOKey;
  }
set SubscriptionDTOKey(value: any) {
    this._SubscriptionDTOKey = value;
    this._key = value;
  }
static setApplications = ($this, items) => {
                if (items == null) items = [];
                if ($this.Applications == null) $this.Applications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Applications.length > 0) {
                    Domain.SubscriptionDTO.removeApplications($this, $this.Applications[0]);
                }

                Domain.SubscriptionDTO.addManyApplications($this, copyItems);
            }
static addManyApplications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SubscriptionDTO.addApplications($this, items[i]);
                }
            }
static addApplications = ($this, item) => {
                if ($this.Applications == null) $this.Applications = [];
                if (item == null || $this.Applications.indexOf(item) > -1) return;
                $this.Applications.push(item);
}
static addRangeApplications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SubscriptionDTO.addApplications($this, item));
            }
static removeApplications = ($this, item) => {
                if ($this == null || $this.Applications == null || $this.Applications.indexOf(item) === -1) return;
                var _index = $this.Applications.indexOf(item);
                $this.Applications.splice(_index, 1);
}
static clearApplications = ($this) => { $this.Applications = null; }
static setBillingDetails = ($this, value) => {
var oldValue = $this.BillingDetails;
$this.BillingDetails = value;
if (value != null) {
}
}

static ToDTO(sub: any,forEndUser: any): any{let dto = new Domain.SubscriptionDTO();
dto.Name = sub?.Name;
dto.CreditsEUR = sub?.CreditsEUR;
Domain.SubscriptionDTO.setApplications(dto, sub?.Applications?.linq?.select((a) => Domain.ApplicationDTO.ToDTO(a))?.toArray());
if (forEndUser) {Domain.SubscriptionDTO.setBillingDetails(dto, Domain.BillingDetailsDTO.ToDTO(sub?.BillingDetails));}
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.SubscriptionDTOKey == null || $this.SubscriptionDTOKey == 0;
            }


}